<template>
  <div>
    <!-- <top /> -->
    <router-view />
    
    <side-menu></side-menu>
  </div>

</template>
<script>
import Top from "@/components/common/Top.vue";

import SideMenu from "@/components/common/SideMenu.vue"
export default {
  components: {
    Top,

    SideMenu
  }
}
</script>
<style>
.el-affix,.el-affix--fixed{
    width:100% !important;
}
</style>
